import React, {
  useMemo,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  Table,
  Alert,
  Image
} from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import DropFileInput from "../../reusable-components/DropFileComponent/DropFileComponent";
import Select from "react-select";
import "./crossReference.css";
import "../../reusable-components/InputFields/elements/customelements.css"
import { Drawer } from "rsuite";
import { ToastContainer, toast } from "react-toastify";
import * as XLSX from "xlsx";
import { getFromLS, setToLS } from "../../utils/storage";
import { logout, capitalizeFirstLetter, updateList, compareLists } from "../../utils";
import { MappingGrid } from "./MappingGrid";
import { OffCanvasDrawer } from "./OffCanvasDrawer";
import { v4 } from "uuid";
import isEqual from 'lodash.isequal';
import clonedeep from 'lodash.clonedeep'
import { makeCygnusApiCall } from "../../api/api";
import { RequiredMappingsModal } from "./RequiredMappingsModal";
import { Bars } from "react-loader-spinner";

const CrossReference = (props) => {
  // console.log("MAPPING PAGE PROPS: ", props)
  const [firmJobs, setFirmJobs] = useState([]);
  const [selectedFirmJob, setSelectedFirmJob] = useState("");
  const [selectedFlowId, setSelectedFlowId] = useState("");
  const [sourceVendor, setSourceVendor] = useState("");
  const [destinationVendor, setDestinationVendor] = useState("");
  const [sourceVendorName, setSourceVendorName] = useState("");
  const [destinationVendorName, setDestinationVendorName] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [originalDataSource, setOriginalDataSource] = useState([]);
  const [endPoints, setEndPoints] = useState({ SourceEndpoints: [], TargetEndpoints: [] });
  const gridStyle = useMemo(() => ({ height: "69vh", width: "100%" }), []);
  const [confirmationModal, setConfirmationModal] = useState(false)
  const handleDialogOpen = () => setConfirmationModal(true);
  // prevent function being recreated on state change
  const handleDialogClose = useCallback(() => setConfirmationModal(false), []);
  const [showRequiredMappingsModal, setShowRequiredMappingsModal] = useState(false);

  const [vendorLevelOptions, setVendorLevelOptions] = useState([]);
  const [refreshGrid, setRefreshGrid] = useState(false)
  
  // Setting page url for helper function
  useEffect(() => {
    setToLS("url", ["myflows"])
  }, [])


  useEffect(() => {
    const getMapping = async () => {
      const data = await makeCygnusApiCall({
        type: "GET",
        payload: {},
        url: "/mapping/",
        show_message: false,
        customized_success_message: "Got your mappings. Let the games begin.",
        customized_failure_message: "Unable to fetch your flow mappings, please try again. If the problem persists, please contact support and attach a screenshot.",
        customized_error_message: "Error occured while fetching your flow mappings, please contact support and attach a screenshot.",
        isblob: false
      })
      if (data["data"] !== undefined) {
        setFirmJobs(data["data"])
      }
    }
    getMapping()
  }, []);

  const handleButtonClick = (event) => {
    const { id } = event;
    setSelectedFirmJob(event);
    if (event.id != "") {
      getMappingEndPoints(event.id)
    }
    for (let flow in firmJobs) {
      if (firmJobs[flow].FlowId == id) {
        setSourceVendor(firmJobs[flow].SourceVendorCode);
        setDestinationVendor(firmJobs[flow].TargetVendorCode);
        setSourceVendorName(firmJobs[flow].SourceVendorName);
        setDestinationVendorName(firmJobs[flow].TargetVendorName);
        setSelectedFlowId(firmJobs[flow].FlowId)
        getVendorMappingLevel(id)
      } else {
        continue
      }
    }
    if (id != "") {
      getAllVendorMappings(id)      
    }
  };

  const getAllVendorMappings = async (flowId) => {
    const data = await makeCygnusApiCall({
      type: "GET",
      payload: {},
      url: `/mapping/${flowId}/`,
      show_message: false,
      customized_success_message: "Got your vendor mappings. Let the games begin.",
      customized_failure_message: "Unable to fetch your vendor mappings for the flow, please try again. If the problem persists, please contact support and attach a screenshot.",
      customized_error_message: "Error occured while fetching your vendor mappings for the flow, please contact support and attach a screenshot.",
      isblob: false
    })
    if (data["data"] != undefined) {
      const ds = data["data"].map((el) => {
        return el;
      });
      setDataSource(ds);
      setOriginalDataSource(clonedeep(ds))
    }
  }

  const getMappingEndPoints = async (flowid) => {
    // console.log("ENDPOINTS flowid", flowid)
    const data = await makeCygnusApiCall({
      type: "GET",
      payload: {},
      url: `/mapping/endpoints/${flowid}/`,
      show_message: false,
      customized_success_message: "Got your flow mapping endpoints. Let the games begin.",
      customized_failure_message: "Unable to fetch your flow mapping endpoints, please try again. If the problem persists, please contact support and attach a screenshot.",
      customized_error_message: "Error occured while fetching your flow mapping endpoints, please contact support and attach a screenshot.",
      isblob: false
    })
    if (data["data"] != undefined) {
      if (Object.keys(data["data"]).length != 0) { setEndPoints(data["data"]) };
    }
  };

  const getVendorMappingLevel = async(flowId) => { 
    setRefreshGrid(true)               
    const data = await makeCygnusApiCall({
        type: "GET",
        payload: {},
        url: `/mapping/vendor_mapping_level?FlowId=${flowId}`,
        show_message: false,
        customized_success_message: "Fetched vendor mapping levels",
        customized_failure_message: "Unable to get mapping levels, please try again. If the problem persists, please contact support and attach a screenshot.",
        customized_error_message: "Error occured while getting the mapping levels, please contact support and attach a screenshot.",
        isblob: false
      })
    // console.log(data);
    setRefreshGrid(false)
    setVendorLevelOptions(data.data);
    
  };


  const AddMappingData = (sourceField, destinationField, customSourceCheck, customDestinationCheck, customFormatCheck, customSourceField, customDestinationField, fieldFormat, dataFields, flowStepNumber) => {
    const updateDataSource = [...dataSource]
    const newSource = customSourceCheck ? customSourceField : sourceField.value
    const newDestination = customDestinationCheck ? customDestinationField : destinationField.value
    const index = dataSource.findIndex(object => (object.SourceField === newSource) && (object.DestinationField === newDestination))
    console.log("DATASOURCE: ", dataSource)
    console.log("INDEX: ", index)
    if (index === -1) {
      updateDataSource.push({
        DestinationField: newDestination,
        FirmVendorMappingId: v4(),
        SourceField: newSource,
        Active: "Y",
        SourceVendorCode: sourceVendor,
        DestinationVendorCode: destinationVendor,
        CustomSource: customSourceCheck,
        CustomDestination: customDestinationCheck,
        CustomFormat: customFormatCheck,
        Format: fieldFormat,
        MappingGroup: newSource + newDestination,
        MappingType: "Fields",
        ReferenceType: "Fields",
        FlowId: selectedFirmJob.id,
        Level: flowStepNumber["value"]
      })
      const newDataFields = dataFields.map((el) => {
        return {
          DestinationField: el.destination,
          FirmVendorMappingId: el.id,
          SourceField: el.source,
          Active: "Y",
          SourceVendorCode: sourceVendor,
          DestinationVendorCode: destinationVendor,
          MappingGroup: newSource + newDestination,
          MappingType: "Data",
          ReferenceType: newDestination,
          FlowId: selectedFirmJob.id,
          Level: flowStepNumber["value"]
        }
      }
      )
      for (let field in newDataFields) {
        updateDataSource.push(newDataFields[field])
      }
      console.log("Final data source: ", updateDataSource)
      setDataSource(updateDataSource)
      AddUpdateDeleteMapping([...updateDataSource])
    } else {
      handleDialogOpen(true)
    }
  }

  const UpdateMappingData = (sourceField, destinationField, customSourceCheck, customDestinationCheck, customFormatCheck, customSourceField, customDestinationField, fieldFormat, dataFields, removedMapping, FirmVendorMappingId, flowStepNumber) => {
    const updateDataSource = [...dataSource]
    const newSource = customSourceCheck ? customSourceField : sourceField.value
    const newDestination = customDestinationCheck ? customDestinationField : destinationField.value
    const index = updateDataSource.findIndex((obj => obj.FirmVendorMappingId === FirmVendorMappingId));
    updateDataSource[index]["SourceField"] = newSource
    updateDataSource[index]["DestinationField"] = newDestination
    updateDataSource[index]["CustomSource"] = customSourceCheck
    updateDataSource[index]["CustomDestination"] = customSourceCheck
    updateDataSource[index]["Format"] = fieldFormat
    updateDataSource[index]["MappingGroup"] = newSource + newDestination
    updateDataSource[index]["CustomFormat"] = customFormatCheck
    updateDataSource[index]["Level"] = flowStepNumber["value"]
    console.log("UPDATE MAPPING METHOD DATAFIELDS RECIEVED: ", dataFields)
    const newDataFields = dataFields.map((el) => {
      return {
        DestinationField: el.destination,
        FirmVendorMappingId: el.FirmVendorMappingId,
        SourceField: el.source,
        Active: "Y",
        MappingGroup: newSource + newDestination,
        SourceVendorCode: sourceVendor,
        DestinationVendorCode: destinationVendor,
        MappingType: "Data",
        ReferenceType: newDestination,
        FlowId: selectedFirmJob.id,
        Level: flowStepNumber["value"]
      }
    }
    )
    const newDataSource = updateList(updateDataSource, newDataFields, "FirmVendorMappingId");
    for (let FirmVendorMappingId of removedMapping) {
      const index = dataFields.findIndex((i) => {
        return i.FirmVendorMappingId === FirmVendorMappingId;
      })
      newDataSource.splice(index, 1)
    }
    setDataSource(newDataSource)
    AddUpdateDeleteMapping(newDataSource)
  }

  const [flowOptions, setFlowOptions] = useState([{
    value: "",
    label: "",
    id: "",
  }]);

  useEffect(() => {
    if (firmJobs.length != 0) {
      const flow_options = firmJobs.map((elem) => {
        return {
          value: elem.DefaultFlowName,
          label: elem.DefaultFlowName,
          id: elem.FlowId,
        };
      })
      setFlowOptions(flow_options)
      if (Object.keys(props.mapoption).length === 0) {
        setSelectedFirmJob(flowOptions[0])
      } else {
        // console.log("FLOW OPTIONS FOR PROPS: ", flow_options)
        if (flow_options[0].id != "") {
          for (let flow in flow_options) {
            if (flow_options[flow].id == props.mapoption.id) {
              // console.log("ENTERING THE MYFLOW MAPPING DOMAIN: ", flow_options)
              setSelectedFirmJob(flow_options[flow])
            } else {
              // console.log("Do nothing!")
            }
          }
        } else {
          // console.log("Do nothing!")
        }

      }
    }
  }, [firmJobs])

  useEffect(() => {
    if (flowOptions[0] != {
      value: "",
      label: "",
      id: "",
    }) {
      if (Object.keys(props.mapoption).length === 0) {
        handleButtonClick(flowOptions[0])
      } else {
        if (flowOptions[0].id != "") {
          for (let flow in flowOptions) {
            if (flowOptions[flow].id == props.mapoption.id) {
              // console.log("ENTERING THE MYFLOW MAPPING DOMAIN: ", flowOptions)
              handleButtonClick(flowOptions[flow])
            } else {
              // console.log("Do nothing!")
            }
          }
        } else {
          // console.log("Do nothing!")
        }

      }
    }
  }, [flowOptions])


  // Custom renderers
  const DotsConnector = () => {
    return (
      <>
        <div className="flowing-loader">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </>
    );
  };

  const FlowConnection = () => {
    
    const selectedFlowObject = firmJobs.find((flow) => flow.FlowId === selectedFlowId);
    // console.log("Selected flow object: ", selectedFlowObject);
    

    if (sourceVendor === "" || destinationVendor === "" || selectedFlowObject === undefined) {
      return <></>
    }

    const sourceVendorLogoLink = selectedFlowObject.SourceVendorLogoLink;
    const targetVendorLogoLink = selectedFlowObject.TargetVendorLogoLink;

    return (
      sourceVendor && destinationVendor ?
        <div className="flowconnection-logo-wrapper" style={{ marginTop: 13, marginBottom: -13 }}>
          <Image
            src={sourceVendorLogoLink}
            className="vendor-logo-mini"
            rounded
          />
          <DotsConnector />
          <Image
            src={targetVendorLogoLink}
            className="vendor-logo-mini"
            rounded
          />
        </div> : <></>
    )
  }

  const ConfirmationModal = (props) => {
    const OverwriteMapping = () => {
    }
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        // backdrop="static"
        centered
        className={"smallmodal"}
      >
        <Modal.Header>
          <div className="flex-row-start-center">
            <Icon.ExclamationCircleFill style={{ fontSize: 20, color: "red", margin: "0px 10px" }} />
            <h6>Mapping already exists!</h6>
          </div>
        </Modal.Header>
        <Modal.Body>
          <p>This mapping already exists. Do you really want to overwrite the mapping? <br /> Doing this will remove any existing relevant custom data mappings as well.</p>
        </Modal.Body>
        <Modal.Footer className="workflow-footer">
          <div className="intent-buttons">
            <Button className="intent-save" onClick={() => OverwriteMapping()}> Overwrite </Button>
            <Button className="intent-skip" onClick={() => handleDialogClose()}> Skip </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  const [updatedList, setUpdatedList] = useState([])
  const [removedList, setRemovedList] = useState([])
  const [addedList, setAddedList] = useState([])
  const AddUpdateDeleteMapping = (newDataSource) => {
    const { updated, removed, added } = compareLists(originalDataSource, newDataSource, "FirmVendorMappingId");
    setUpdatedList(updated)
    setAddedList(added)
    setRemovedList(removed)
    setOriginalDataSource(clonedeep(newDataSource))
  }

  useEffect(() => {
    const addate = [...updatedList, ...addedList]
    if (addate.length !== 0) {
      console.log("ADDATE: ", addate)
      AddateMapping(addate)
    }

    if (removedList.length !== 0) {
      console.log("REMOVED: ", removedList)
      DeleteMapping(removedList)
    }
  }, [updatedList, removedList, addedList])


  const AddateMapping = async (addate) => {
    const _ = await makeCygnusApiCall({
      type: "POST",
      payload: addate,
      url: `/mapping/`,
      show_message: true,
      customized_success_message: "Saved your mapping.",
      customized_failure_message: "Unable to save your mapping data, please try again. If the problem persists, please contact support and attach a screenshot.",
      customized_error_message: "Error occured while saving your mapping data, please contact support and attach a screenshot.",
      isblob: false
    })
  }

  const DeleteMapping = async (removed) => {
    let dataToBeDeleted = removed.map((el) => {
      return {
        FirmVendorMappingId: el.FirmVendorMappingId,
      };
    });
    console.log("DATA TO BE DELETED: ", dataToBeDeleted)
    const data = await makeCygnusApiCall({
      type: "DELETE",
      payload: dataToBeDeleted,
      url: `/mapping/`,
      show_message: false,
      customized_success_message: "Mapping was deleted..",
      customized_failure_message: "Unable to delete your mapping, please try again. If the problem persists, please contact support and attach a screenshot.",
      customized_error_message: "Error occured while deleting your mapping, please contact support and attach a screenshot.",
      isblob: false
    })
    if (data.success) {
      setRemovedList([])
    }
  }

  // handleRequiredMappings
  const handleRequiredMappings = () => {
    setShowRequiredMappingsModal(true);
  };

  return (
    <Container fluid>
      <ConfirmationModal
        show={confirmationModal}
        onHide={() => handleDialogClose()}
      />
      <Row>
        {/* <Col md={2}>
        </Col> */}
        <Col md={12} >

          <Row>
            <Col xs={10}>
              <h2 className="display-6">Mapping</h2>
            </Col>
            <Col xs={2}></Col>
          </Row>
          <Row className="mb-4 flex-row-center-start">
            <Col xs={2}>
              <FlowConnection />
            </Col>
            <Col xs={4} className="mt-3">
              <h6>Flow</h6>
              {firmJobs && (
                <Select
                  onChange={handleButtonClick}
                  value={selectedFirmJob}
                  defaultValue={flowOptions[0]}
                  placeholder={<div>Select Flow ..</div>}
                  options={flowOptions}
                  className='custom-select '
                  classNamePrefix="react-select"
                />
              )}
            </Col>
            <Col xs={2}>
              <h6 style={{
                padding: "7px",
              }}>Source Vendor</h6>
              <span style={{
                padding: "10px",
                display: "block",
                background: "#f1f3f4",
                width: "100%",
                borderRadius: "5px"
              }}>{sourceVendorName}</span>
            </Col>
            <Col xs={2}>
              <h6 style={{
                padding: "7px",
              }}>Destination Vendor</h6>
              <span style={{
                padding: "10px",
                display: "block",
                background: "#f1f3f4",
                width: "100%",
                borderRadius: "5px"
              }}>{destinationVendorName}</span>
            </Col>

            <Col xs={2}>
              <h6 style={{
                padding: "7px",
              }}>&nbsp;</h6>
              <Button
                className="custom-button"
                style={{ float: "left", margin: "0 0 10px 10px" }}
                onClick={() => handleRequiredMappings()}
              >
                <Icon.InfoCircle /> Help/Show Required Mappings
              </Button>
            </Col>

          </Row>

          {selectedFirmJob &&
            sourceVendor &&
            destinationVendor &&
            dataSource && (
              <div className="cross-reference-grid">
                <div className="ag-theme-balham" style={gridStyle}>
                  { !refreshGrid ? 
                    <MappingGrid
                      dataSource={dataSource}
                      setDataSource={(item) => setDataSource(item)}
                      selectedFirmJob={selectedFirmJob}
                      sourceVendor={sourceVendor}
                      destinationVendor={destinationVendor}
                      getAllVendorMappings={() => getAllVendorMappings(selectedFirmJob.id)}
                      addDataMapping={(sourceField, destinationField, customSourceCheck, customDestinationCheck, customFormatCheck, customSourceField, customDestinationField, fieldFormat, dataFields, flowStepNumber) =>
                        AddMappingData(sourceField, destinationField, customSourceCheck, customDestinationCheck, customFormatCheck, customSourceField, customDestinationField, fieldFormat, dataFields, flowStepNumber)
                      }
                      updateDataMapping={(sourceField, destinationField, customSourceCheck, customDestinationCheck, customFormatCheck, customSourceField, customDestinationField, fieldFormat, dataFields, removedMapping, FirmVendorMappingId, flowStepNumber) =>
                        UpdateMappingData(sourceField, destinationField, customSourceCheck, customDestinationCheck, customFormatCheck, customSourceField, customDestinationField, fieldFormat, dataFields, removedMapping, FirmVendorMappingId, flowStepNumber)
                      }
                      endPoints={endPoints}
                      vendorleveloptions={vendorLevelOptions}
                      refreshGrid={refreshGrid}
                    />
                  : 
                    <div className="flex-row-center-center" style={{ marginTop: "16%" }}>
                      <div className="spinner flex-column-center-center" style={{ fontSize: 14, fontWeight: 500 }}>
                        <Bars
                          height="80"
                          width="80"
                          color="var(--theme1_primary)"
                          ariaLabel="bars-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={true}
                        />
                        Loading your data
                      </div>
                    </div>                    
                  }
                </div>
              </div>
            )}
        </Col>
      </Row>

      <RequiredMappingsModal
        show={showRequiredMappingsModal}
        sourceVendor={sourceVendorName}
        destinationVendor={destinationVendorName}
        onHide={() => setShowRequiredMappingsModal(false)}
        flowId={selectedFlowId}
      />

    </Container>
  );
};

export default CrossReference;
